// @flow

import React from 'react';
import { connect } from 'react-redux';
import ConfigPackage from '../configPackage';
import Slider from '../../../slider';
import { getPackages } from '../../../../store/configuration/actives';
import { selectPackage } from '../../../../store/configuration';
import type { Package } from '../../../../types/pdb';
import { breakpointsPx } from '../../../../helpers/breakpoints';
import { isSoldOutPackage } from '../../../../store/pdb/selectors';

type StateProps = {|
  packages: Array<Package>,
|};

type DispatchProps = {|
  setPackage: Function,
|};

type Props = {|
  ...StateProps,
  ...DispatchProps,
|};

// type Props = StateProps & DispatchProps;

const ConfigPackagesSlider = ({
  packages,
  setPackage,
}: Props) => (
  <Slider
    totalSlides={packages.length}
    perPage={{
      [breakpointsPx.lg]: 3,
      [breakpointsPx.md]: 3,
      [breakpointsPx.sm]: 2,
    }}
  >
    {packages.map((pdbPackage: Package) => {
      const {
        name,
        id,
        price,
        contains,
        default_image,
      } = pdbPackage;
      return (
        <ConfigPackage
          title={name || ''}
          key={id}
          packageId={id || 0}
          price={price || ''}
          contains={contains || []}
          image={default_image}
          onClick={() => setPackage(id)}
          blockCount={packages.length}
          soldOut={isSoldOutPackage(pdbPackage)}
        />
      );
    })}
  </Slider>
);

const mapStateToProps = (state): StateProps => ({
  packages: getPackages(state),
});

const mapDispatchToProps = (dispatch: Function): DispatchProps => ({
  setPackage: (id: number) => dispatch(selectPackage(id)),
});

export default connect<Props, any, StateProps, DispatchProps, any, any>(
  mapStateToProps,
  mapDispatchToProps,
)(ConfigPackagesSlider);
